import { useNotification } from 'admin';
import { useApiTradeV1BuyerMaterialSpecificationsDestroy } from 'api';
import { useNavigate, useParams } from 'react-router-dom';

export const useDeleteBuyerMaterialSpecification = () => {
  const { open } = useNotification();
  const { companyId } = useParams();
  const navigate = useNavigate();
  return useApiTradeV1BuyerMaterialSpecificationsDestroy({
    mutation: {
      onError: (error) => {
        open?.({
          message: `Failed to delete material spec: ${error}`,
          type: 'error',
        });
      },
      onSuccess: () => {
        navigate(`/ground-control/v2/manage-company/${companyId}/material-specifications`);
      },
    },
  });
};
